import axios from "../http_v2";

export default {
  list: (params) => {
    return axios.post('websitecenter/content/page', params)
  },
  save: (params) => {
    return axios.post('websitecenter/content/save', params)
  },
  del: (params) => {
    return axios.get('websitecenter/content/delete', params)
  },
  detail:  (params) => {
    return axios.get('websitecenter/content/netapi/list', params)
  }
}
